import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { IDispositionskennzeichen } from '../_interfaces/dispositionskennzeichen';

import { DispositionskennzeichenService } from '../_services/dispositionskennzeichen.service';

@Pipe({
  name: 'dispositionskennzeichen'
})
export class DispositionskennzeichenPipe implements PipeTransform {
  constructor(
    private dispositionskennzeichenService: DispositionskennzeichenService,
  ) { }

  transform(value: unknown, ...args: unknown[]): unknown { // args[0] muss gleich VU sein!
    //console.log("DispositionskennzeichenPipe.transform() value, args[0]: ", value, args[0]);
    if(value == null) return of('');

    return this.dispositionskennzeichenService.getDispositionskennzeichenForVersorgungsunternehmen(args[0] as string, 'D')
    .pipe(
      map(response => {
        //console.log("DispositionskennzeichenPipe.transform(): response:", response);
        let search = value as number;
        let found = response.dispositionskennzeichen.find(f => f.kennzeichenNr == search);
        if(found != null) return found.bezeichnung;
        else return null;
      })
      , catchError(error => {
        console.error("DispositionskennzeichenPipe.transform()error: ", error);
        return of('');
      })
    );
  }

}
